export enum EReputationAnalysisCode {
  X_PEP = "x_pep",
  X_SANCTION = "x_sanction",
  FALSE_POSITIVE = "fp",
}

/**
 * @description
 * - POTENTIAL : Dowjones a détecté un risque potentiel, l'utilisateur doit le confirmer
 * - CONFIRMED : L'utilisateur a confirmé le risque
 * - NO_ANALYSIS : Il n'y a pas encore eu l'analyse Dowjones
 * - NO_ALERT : Dowjones ne détecte pas de risque
 * - FALSE_POSITIVE : L'utilisateur a déclaré un faux positif
 */
export enum EReputationStatus {
  POTENTIAL = "potential",
  CONFIRMED = "confirmed",
  NO_ANALYSIS = "no_analysis",
  NO_ALERT = "no_alert",
  FALSE_POSITIVE = "false_positive",
}

export enum EReputationAnalysisStatus {
  RAS = "RAS",
  X = "X",
  FAUX_POSITIF = "Faux positif",
}

export enum EReputationCategory {
  PEP = "pep",
  SANCTION = "sanction",
}

export const ALL_FALSE_POSITIVE = "allFalsePositive";
